import Cookies from 'universal-cookie'

// export const BASE_URL = "http://127.0.0.1:5000"
export const BASE_URL = "https://todos-app-flask-v2.onrender.com"
export const cookies = new Cookies();
